var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emptyLayoutContainer wrapper appWrapper"},[_c('c-errors'),_c('router-view',{staticClass:"viewContainer",attrs:{"id":"routerViewport"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }